import React from 'react';
import { Link } from 'react-router-dom';
import SubscribeSection from '../components/SubscribeSection';

const Home = () => {
  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="hero-logo">
            <img src="/images/logo.png" alt="Containerized Conversations Logo" />
          </div>
          <h2>Welcome to Containerized Conversations</h2>
          <p>Your podcast for all things containers, Kubernetes, and cloud-native technologies</p>
          <div className="hero-buttons">
            <Link to="/episodes" className="btn">Listen Now</Link>
            <Link to="/about" className="btn btn-secondary">Learn More</Link>
          </div>
        </div>
      </section>

      <section className="latest-episode">
        <div className="container">
          <h2>Now Live!</h2>
          <p>Containerized Conversations is now available on your favorite podcast platforms. Join hosts Jesse Cafarelli and Josh Warhurst as they dive deep into the world of containers, Kubernetes, and cloud-native technologies with expert guests and practical insights.</p>
          <p>Check out our latest episodes where we explore topics that matter to developers, DevOps engineers, and technology leaders who are building and deploying modern applications.</p>
          <div className="episode-cta">
            <Link to="/episodes" className="btn">Browse Episodes</Link>
          </div>
        </div>
      </section>

      <section className="topics" id="topics">
        <div className="container">
          <h2>Topics We Cover</h2>
          <div className="topics-grid">
            <div className="topic-card">
              <div className="topic-icon">
                <i className="icon-container"></i>
              </div>
              <h3>Container Orchestration</h3>
              <p>Deep dives into Kubernetes, Docker Swarm, and other orchestration platforms that power modern infrastructure.</p>
            </div>
            <div className="topic-card">
              <div className="topic-icon">
                <i className="icon-microservices"></i>
              </div>
              <h3>Microservices Architecture</h3>
              <p>Strategies and best practices for designing, deploying, and managing microservices in containerized environments.</p>
            </div>
            <div className="topic-card">
              <div className="topic-icon">
                <i className="icon-security"></i>
              </div>
              <h3>Container Security</h3>
              <p>Essential security considerations and tools to protect your containerized applications from vulnerabilities.</p>
            </div>
          </div>
        </div>
      </section>

      <div id="subscribe">
        <SubscribeSection />
      </div>
    </>
  );
};

export default Home;